//export const serverApiUrl = 'http://localhost:8080/api/v1/';

import { HttpHeaders } from '@angular/common/http';

export const INTERCEPTOR_SKIP = 'X-Skip-Interceptor';
const InterceptorSkipHttpHeader = new HttpHeaders({
  'X-Skip-Interceptor': ''
});
export const InterceptorSkipHeader = { headers: InterceptorSkipHttpHeader};
